import fetch from '@/utils/fetch';
import { urlFun } from '@/utils/encryption';

let _url = 'http://192.168.0.3:8888';

export function axGet(_cmd, _param) {
  return fetch({
    url: '/Rat/EventHandle',
    method: 'get',
    params: {
      json: JSON.stringify(urlFun(_cmd, _param)),
    },
  });
}
export function axPost(_cmd, _param) {
  return fetch({
    url: '/Rat/EventHandle',
    method: 'post',
    data: {
      json: JSON.stringify(urlFun(_cmd, _param)),
    },
    transformRequest: [
      function (data) {
        let ret = '';
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
        }
        return ret;
      },
    ],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
}
